import React from "react";
import gameapartSklogo from "../../../../assets/images/slide-kick/gameApart-sklogo.png";

const Over = ({ param }) => {
  return (
    <div>
      <div className="slidekick-section">
        <div className="slidekick-inner">
          <div className="presented-heading">
            <h3>{param.presented_with}</h3>
            <h1>HeyLIME SlideKick</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Over;
